import CategoryPage from './themes/BGH/CategoryPage';

export default CategoryPage;
